export const TRACKING_PROVIDERS = {
  STATSCORE: 'statscore',
  STATSCORE_V3: 'statscoreV3',
  BETRADAR_V2: 'betradarV2',
  BETRADAR: 'betradar',
  BETRADAR_V3: 'betradarV3',
  BSPORTS: 'bsports',
  BETGENIUS: 'betgenius',
};

export const SPORTS_CLASS = {
  SOCCER: 'soccer',
  BASKETBALL: 'basketball',
  BASEBALL: 'baseball',
  ICE_HOCKEY: 'ice-hockey',
  TENNIS: 'tennis',
  HANDBALL: 'handball',
  VOLLEYBALL: 'volleyball',
  BEACH_VOLLEYBALL: 'beach-volley',
  WATERPOLO: 'waterpolo',
  FUTSAL: 'futsal',
  TABLE_TENNIS: 'table-tennis',
  BADMINTON: 'badminton',
  FIFA: 'fifa',
  NBA2K: 'esports-nba-2ka',
  RUGBY_LEAGUE: 'rugby-league',
  RUGBY: 'rugby',
  AMERICAN_FOOTBALL: 'football',
};

export const AVAILABLE_LIVE_TRACKERS = [
  { id: SPORTS_CLASS.SOCCER, name: 'soccer-tracker' },
  { id: SPORTS_CLASS.BASKETBALL, name: 'basketball-tracker' },
  { id: SPORTS_CLASS.BASEBALL, name: 'baseball-tracker' },
  { id: SPORTS_CLASS.ICE_HOCKEY, name: 'hockey-tracker' },
  { id: SPORTS_CLASS.TENNIS, name: 'tennis-tracker' },
  { id: SPORTS_CLASS.HANDBALL, name: 'handball-tracker' },
  { id: SPORTS_CLASS.VOLLEYBALL, name: 'volleyball-tracker' },
  { id: SPORTS_CLASS.BEACH_VOLLEYBALL, name: 'beach-volleyball-tracker' },
  { id: SPORTS_CLASS.WATERPOLO, name: 'waterpolo-tracker' },
  { id: SPORTS_CLASS.FUTSAL, name: 'futsal-tracker' },
  { id: SPORTS_CLASS.TABLE_TENNIS, name: 'table-tennis-tracker' },
  { id: SPORTS_CLASS.BADMINTON, name: 'badminton-tracker' },
  { id: SPORTS_CLASS.FIFA, name: 'fifa-tracker' },
  { id: SPORTS_CLASS.NBA2K, name: 'nba2k-tracker' },
  { id: SPORTS_CLASS.RUGBY_LEAGUE, name: 'rugby-tracker' },
  { id: SPORTS_CLASS.RUGBY, name: 'rugby-tracker' },
  { id: SPORTS_CLASS.AMERICAN_FOOTBALL, name: 'american-football-tracker' },
];
